import { BrowserRouter } from 'react-router-dom';
import { ToastProvider, Toaster } from '@/components/ui/Toast';
import { AppRoutes } from './router';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AppRoutes />
        <Toaster />
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
